import Vue from 'vue'
import Vuex from 'vuex'
import api from '../wl-core/api'
import UserDetails from "../wl-core/api/classes/UserDetails";
import jsCookies from 'js-cookie'
import router from '@/router/index'
import {BranchDetails} from "../wl-core/api/classes/BranchDetails";
import Loading from "../wl-core/components/Loading";
import XLSX from "xlsx";
import moment from "moment";
import coreStore from "../wl-core/stores/coreStore";
import firebase from "firebase";
import config from "../config";
import branchStore from "../wl-core/stores/branchStore"
import projectStore from "../wl-core/stores/projectStore"

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        /*----*/
        partners: [],
        ongoingCallouts: [],
        openDepts: [],
        openDeptMove: [],
        openIssues: [],
        closedIssues: [],
        recentMaintenances: [],
        issueTypes: [],
        timer: null,
        issueTimer: null,
        subdomain: null
    },
    mutations: {

        setSubDomain(state) {
            let domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];
            state.subdomain = domain.split(':')[0].split('.')[0]
        },
        setRecentMaintenances(state, maintenances) {
            state.recentMaintenances = maintenances
        },
        setIssueTypes(state, issueTypes) {
            state.issueTypes = issueTypes;
        },
        setOpenDepts(state, depts) {
            state.openDepts = depts;
        },
        setDeptMoves(state, depts) {
            state.openDeptMove = depts;
        },
        setOngoingCallouts(state, events) {
            state.ongoingCallouts = events;
        },
        addCloseIssue(state, issue) {
            this.state.closedIssues.push(issue);
        },
        setPartners(state, partners) {
            state.partners = partners;
        },
        setOpenIssues(state, issues) {
            Vue.set(state, 'openIssues', issues);
        },
        setClosedIssues(state, issues) {
            Vue.set(state, 'closedIssues', issues)
        },
        removeData(state) {
            clearInterval(state.timer);

            state.ongoingCallouts = [];
            state.openDepts = [];
            state.openIssues = [];
            state.partners = []
        },
        clearTimer(state) {
            clearInterval(state.timer);
            state.timer = null;
        },
        clearIssueTimer(state) {
            clearInterval(state.issueTimer);
            state.issueTimer = null;
        },
    },
    actions: {
        init({state, commit, dispatch}) {
            if(!state.partners.length){
                dispatch('getPartnerDetails').then(
                    resp => {
                        dispatch('getOngoingCallouts').then(() => {
                            commit('setCalloutLoading', false);
                        })
                        dispatch('getOpenDepts', {}).then(() => {
                            commit('setOpenDeptsLoading', false)
                        })
                        dispatch('getOpenIssues').then(() => {
                            commit('setOpenIssuesLoading', false)
                        })
                        dispatch('getRecentMaintenances').then(() => {
                            commit('setMaintenancesLoading', false)
                        })
                    })
            }

        },
        getIssues({}, options) {
            return api.issues.getIssues(options)
        },
        getOpenIssues({state, commit}) {
            commit('clearIssueTimer');
            return api.issues.getIssues({Finished: false})
                .then(issues => {
                    commit('setOpenIssues', issues);
                    state.issueTimer = setInterval(() => api.issues.getIssues({Finsished: false})
                        .then(events => commit("setOpenIssues", events)), 60000
                    )
                })

        },
        getClosedIssues({commit}) {
            return api.issues.getIssues({Finished: true})
                .then(issues => {
                    commit('setClosedIssues', issues)
                })
        },

        logout({commit}) {
            commit('logout');
            commit('clearIssueTimer');
            commit('removeData');
            commit('project/resetProject');
            router.push('/login')
        },

        getIssueTypes({commit, state}, fromCache) {
            if (fromCache && state.issueTypes.length > 0) {
                return Promise.resolve(state.issueTypes);
            } else {
                return api.issues.getIssueTypes().then(
                    issueTypes => {
                        commit('setIssueTypes', issueTypes);
                        return Promise.resolve(issueTypes);
                    }
                )
            }
        },
        getDeptMoveDetails({commit}, options) {
            return api.depts.getDeptMoveDetails(options).then(
                deptMoves => {
                    deptMoves = deptMoves.sort((a, b) => new Date(a.HmeromOriginal) - new Date(b.HmeromOriginal));
                    commit('setDeptMoves', deptMoves);
                    return Promise.resolve(deptMoves);
                }
            )
        },
        getOpenDepts({commit}, options) {
            return api.depts.getDeptDetails(options).then(
                depts => {
                    depts = depts.sort((a, b) => new Date(b.DateInvoice) - new Date(a.DateInvoice));
                    commit('setOpenDepts', depts);
                    return Promise.resolve(depts);
                }
            )
        },
        getAllEvents({commit}, options) {
            commit('showLoading');
            commit('setLoadingMessage', 'Φόρτωση γεγονότων');
            return api.events.getEventDetails(options)
                .then(resp => {
                    commit('hideLoading');
                    return Promise.resolve(resp.sort((a, b) => new Date(b.DateEventInsert) - new Date(a.DateEventInsert)));
                })
        },
        getSingleEvent({commit}, id) {
            commit('showLoading');
            commit('setLoadingMessage', 'Μίσο λεπτό...');
            return api.events.getEventDetails({Event_ID: id})
                .then(event => {
                        commit('hideLoading');
                        return Promise.resolve(event[0])
                    }
                );
        },

        getFrontPageDetails({}, subdomain) {
            return api.login.getFrontPageDetails(subdomain)
        },

        changePassword({commit, dispatch, state, getters}, {newPassword, oldPassword}) {
            commit('showLoading');
            commit('setLoadingMessage', 'Μίσο λεπτό...');
            return api.login.changePassword(getters.userDetails.Username, oldPassword, newPassword)
                .then(result => {
                    commit('hideLoading');
                    dispatch('logout');
                    return Promise.resolve(true)
                })
        },

        getRecentMaintenances({state, commit}) {
            api.events.getEventDetails({EventType_ID: 1, LastDays: 31,  Status_ID: 1}).then(events => {
                commit('setRecentMaintenances', events)
            })
        },
        getOngoingCallouts({state, commit}) {
            api.events.getEventDetails({EventType_ID: 2, Status_ID: 4})
                .then(events => commit("setOngoingCallouts", events));
            if (state.timer === null) {
                state.timer = setInterval(() => api.events.getEventDetails({EventType_ID: 2, Status_ID: 4})
                    .then(events => commit("setOngoingCallouts", events)), 60000
                )
            }
        },
        replyIssue({commit, dispatch, getters}, reply) {
            commit('showLoading');
            commit('setLoadingMessage', ' Η απάντηση σας αποστέλνεται...');
            return api.issues.replyToIssue(reply).then(() => {
                commit('setLoadingMessage', 'Λήψη ανοιχτών θεμάτων...');
                return dispatch('getOpenIssues').then(resp => {
                    api.misc.sendEmail({
                        subject: `Winlift Managers: O/η ${getters.userDetails.Fullname} απάντησε στο αίτημα ${reply.Issue_ID}`,
                        body: `========== Αίτημα: ${reply.ActionNotes}. ================ Απαντήστε στο αίτημα αυτό πηγαίνοντας
                         στο Winlift Next -> Μενού ->  Θέματα -> Διαχείριση Θεμάτων -> Αιτήματα Διαχειριστών, επιλέγοντας την ενέργεια Γραφείο`

                    })
                    commit('hideLoading');
                })
            })
        },
        addIssue({commit, getters}, issue) {
            commit('showLoading');
            commit('setLoadingMessage', 'To αίτημα σας δημιουργείται...');
            return api.issues.addIssue(issue).then(
                resp => {
                    commit('hideLoading');
                    api.misc.sendEmail({
                        subject: `Winlift Managers: O/η ${getters.userDetails.Fullname} έστηλε νέο Αίτημα`,
                        body: `========== Αίτημα: ${issue.Description}. ================ Απαντήστε στο αίτημα αυτό πηγαίνοντας
                         στο Winlift Next -> Μενού ->  Θέματα -> Διαχείριση Θεμάτων -> Αιτήματα Διαχειριστών, επιλέγοντας την ενέργεια Γραφείο`

                    })
                    return Promise.resolve(resp.data.Data)
                }
            );
        },

        addPayments({state, commit}, {PaymentGate, PaymentItems, TotalAmount, File, Fullname}) {
            commit('showLoading');
            commit('setLoadingMessage', 'Η πληρωμή καταχωρείτε...')

            let body = `            
             o/η ${Fullname}  πραγματοποιήσε μια πληρώμη μέσω ${PaymentGate} από την πλατφόρμα Winlift Managers: \x0D

                ${PaymentItems.map((item) => {
                return '' + item.Description
            }).join('\x0D')}
             `

            let subject = `Winlift Managers: o/η ${Fullname} πραγματοποιήσε μια πληρώμη`
            return api.depts.addPayments({
                DateInsert: moment().toISOString(),
                PaymentGate: PaymentGate,
                PaymentItems: PaymentItems,
                TotalAmount: TotalAmount
            })
                .then(resp => {
                    commit('hideLoading');
                    return Promise.resolve(resp.data)
                })
                .then(resp => {
                    api.misc.sendEmail({body: body, subject: subject, file: File})
                })
        },

        addCallout({commit, dispatch}, callout) {
            commit('showLoading');
            commit('setLoadingMessage', 'Η βλάβη δημιουργείται...');
            return api.events.addCallout(callout).then(
                resp => {
                    commit('setLoadingMessage', 'Λήψη ανοιχτών βλαβών...');
                    return dispatch('getOngoingCallouts').then(resp => {
                        commit('hideLoading');
                    })
                }
            );
        },
        getPartnerDetails({state, commit}) {
            if (state.partners.length) {
                return Promise.resolve(state.partners)
            } else {
                return api.partners.getPartnerDetails().then(partnerDetails => {
                    commit('setPartners', partnerDetails);
                    return Promise.resolve(state.partners)
                })
            }
        }
    },
    getters: {
        closedIssues: s => s.closedIssues.sort((a, b) => {
            return new Date(b.getLastAction().DateInsert) - new Date(a.getLastAction().DateInsert)
        }),
        issueType: s => (id) => s.issueTypes.find(it => it.IssueType_ID === id),
        totalDept: s => s.openDepts.map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0),
        totalDeptStandBy: s => s.openDepts.filter(d => d.StandBy === true).map(d => d.Balance).reduce((a, c) => Number(a) + Number(c), 0),
        ongoingCallout: s => (id) => s.ongoingCallouts.find(s => s.Event_ID === id),
        partners: s => s.partners,
        openDepts: s => s.openDepts,
        deptMoves: s => s.openDeptMove,
        openIssues: s => s.openIssues.sort((a, b) => {
            return new Date(b.getLastAction().DateInsert) - new Date(a.getLastAction().DateInsert)
        }),
        recentMaintenances: s => s.recentMaintenances.sort((a, b) => {
            return new Date(b.DateEnd) - new Date(a.DateEnd)
        }),
        ongoingCallouts: s => s.ongoingCallouts,
        partner: s => id => s.partners.find(p => p.Partner_ID === id),
        branch: (state, getters) => (id) => getters.branches.find(b => b.Branch_ID === id),
        branches: s => {
            let buildings = [];
            s.partners.forEach(p => {
                p.Branches.forEach(b => {
                    let branch = new BranchDetails(b);
                    branch.Partner_ID = p.Partner_ID;
                    branch.PartnerBrandName = p.PartnerBrandName;
                    branch.PartnerFullName = p.PartnerFullName;
                    buildings.push(branch)
                });
            });
            return buildings;
        },
        projects: s => {
            let elevators = []
            s.partners.forEach(p => {
                p.Branches.forEach(b => {
                    let branch = new BranchDetails(b);
                    branch.Partner_ID = p.Partner_ID;
                    branch.PartnerBrandName = p.PartnerBrandName;
                    branch.PartnerFullName = p.PartnerFullName;
                    branch.Projects.forEach(pr => {
                        elevators.push(pr);
                    });

                });
            });
            return elevators
        }
        ,

        maintenanceMonth: s => {
            let month = new Date().getMonth();
            let elevators = [];
            s.partners.forEach(p => {
                p.Branches.forEach(b => {
                    let branch = new BranchDetails(b);
                    branch.Partner_ID = p.Partner_ID;
                    branch.PartnerBrandName = p.PartnerBrandName;
                    branch.PartnerFullName = p.PartnerFullName;
                    branch.Projects.forEach(pr => {
                        if (moment(pr.EktHmerSint).month() === month) elevators.push({elevator: pr, branch: branch})
                    });

                });
            });
            return elevators.sort((a, b) => {
                return new Date(a.elevator.EktHmerSint) - new Date(b.elevator.EktHmerSint)
            });
        },
    },
    modules: {
        coreStore: coreStore,
        branch: branchStore,
        project: projectStore
    }
})
